import { render } from "./invoiceSummary.vue?vue&type=template&id=2025dcc7"
import script from "./invoiceSummary.vue?vue&type=script&lang=js"
export * from "./invoiceSummary.vue?vue&type=script&lang=js"

import "./invoiceSummary.vue?vue&type=style&index=0&id=2025dcc7&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__